import { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getComapnyByKey, HeaderCartIcon, useCompanyByStorage, useProjectByStorage } from '../projectData';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { ProfileDrawer } from '../dashboard/profileDrawer';
import { useRouteData } from '../RouteDataContext';



/**
 * CustomerHeader
 * Renders the main customer header with logo, navigation, and logout functionality.
 */
export const CustomerHeader = ({ heading, url = '', notFound = '', isUrl }) => {
    const { dashboard } = useRouteData();
    useEffect(() => {
        // Scroll to top when this component is mounted
        window.scrollTo(0, 0);
    }, []);
    const project = useCompanyByStorage();
    const navigate = useNavigate();
    const userId = useParams()
    let UrlWithId
    if (heading === "Kyc Details") {
        if (project?.cname === 'corteva') {
            UrlWithId = '/customer/scheme-dashboard'
        } else {
            UrlWithId = url
        }
    } else {
        UrlWithId = userId?.userId ? `${url}/${userId?.userId}` : url;
    }

    const logOut = (cname) => {
        if (cname) {
            const project = getComapnyByKey(cname);
            localStorage.removeItem('cuslogin');
            localStorage.removeItem('company_login');
            localStorage.removeItem('company');
            localStorage.removeItem('pkey');
            localStorage.removeItem('welcomePopup');


            if (project.cname) {
                window.location.href = `/customer/${project.cname}/login`;
            }
        }

    }

    return (
        <div className="card m-0 bg-light-danger">
            {!project?.web_link &&
                <div className='hstack justify-content-between userdashboard align-self-auto align-items-center bg-white'>
                    <div style={{ background: '#ffffff' }} className='h-65px text-white' >
                        <div className="aside-logo pt-6 ps-4 " id="kt_aside_logo">
                            <img alt="Logo" src={toAbsoluteUrl(project?.logo)} className="h-30px logo" />
                        </div>
                    </div>
                    <div className="d-flex align-items-center me-2 h-25px gap-3">
                        <img alt="Logo" src={'/media/images/RePay.png'} className="h-25px logo" />
                        <div class="vr" ></div>
                        <button
                            type="button"
                            onClick={() => logOut(project?.cname)}
                            className="btn btn-link text-decoration-none p-0"
                            aria-label="Logout"
                        >
                            <i className="fs-1 bi bi-box-arrow-right" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            }

            <div className="d-flex align-items-center userdashboard justify-content-between p-2">
                {isUrl ? <>
                    {heading === 'Dashboard' ? (
                        <>
                            {project?.dashboard_backurl ?
                                <Link to={project?.dashboard_backurl}>
                                    <h1 className="fw-semibold ms-2 mb-0 fw-semibolder">  <i
                                        className="bi bi-chevron-double-left fs-1 text-dark"
                                        style={{ fontWeight: 'bold' }}
                                    ></i>{' '}{heading}</h1>
                                </Link>
                                : <div className='d-flex align-items-center ms-2 ps-2'>
                                    {project?.sidemenu && <ProfileDrawer />}
                                    <h3 className="fw-semibold ms-2   mb-0 fw-semibolder"> {heading}</h3>
                                </div>
                            }
                        </>
                    ) : <Link to={UrlWithId}>
                        <h3 className="fw-semibold  mb-0 fw-semibolder">
                            <i className="bi bi-chevron-double-left fs-1 text-dark"
                                style={{ fontWeight: 'bold' }}
                            ></i>{' '}
                            {heading}
                        </h3>
                    </Link>
                    }
                </>
                    : <>
                        {heading === 'Schemes' ? (
                            <>
                                <div className='d-flex align-items-center ms-2 ps-2'>
                                    <i style={{ fontWeight: 'bold' }} class="bi fs-1 text-dark bi-list"></i>
                                    <h3 className="fw-semibold ms-2   mb-0 fw-semibolder"> {heading}</h3>
                                </div>
                            </>
                        ) :
                            <button type="button" onClick={() => navigate(-1)} className="btn btn-link p-0" aria-label="Go back">

                                <h3 className="fw-semibold  mb-0 fw-semibolder">
                                    <i className="bi bi-chevron-double-left fs-1 text-dark"
                                        style={{ fontWeight: 'bold' }}
                                    ></i>{' '}
                                    {heading}
                                </h3>
                            </button>
                        }
                    </>
                }
                {project?.add_to_cart &&
                    <HeaderCartIcon count={dashboard?.cartCount} project={project} />
                }

            </div>
        </div>
    );
};

/**
 * PageHeader
 * Renders a page header for customer pages with project/company info.
 */
export const PageHeader = ({ heading }) => {

    const project = useProjectByStorage();
    return <div className="card p-0 m-0 bg-light-danger">
        <div className='d-flex justify-content-between bg-white'>
            <div style={{ background: '#ffffff' }} className='h-65px text-white' >
                <div className="aside-logo pt-6 ps-4 " id="kt_aside_logo">
                    <img alt="Logo" src={toAbsoluteUrl(project?.logo)} className="h-30px logo" />
                </div>
            </div>

        </div>

        <div className="d-flex align-items-center justify-content-between p-2">

            <Link to='/customer/mitr/login'>
                <h3 className="fw-semibold  mb-0 fw-semibolder">
                    <i className="bi bi-chevron-double-left fs-1 text-dark"
                        style={{ fontWeight: 'bold' }}
                    ></i>{' '}
                    {heading}
                </h3>
            </Link>
        </div>
    </div>

}

/**
 * AddressVerificationHeader
 * Renders the header for address verification pages, displays logo.
 */
export const AddressVerificationHeader = () => {
    const url = localStorage.getItem('logo_url')
    return <div className='d-flex justify-content-between bg-white'>
        <div>
            <img alt="Logo" src={url} className="h-30px logo" />
        </div>
        <div>
            <img alt="Logo" src={'/media/images/RePay.png'} className="h-30px logo" />
        </div>
    </div>

}

/**
 * CommunicationHeader
 * Renders the header for communication preference pages.
 */
export const CommunicationHeader = ({ data }) => {

    return <div className='d-flex justify-content-between  py-4 px-4' style={{ backgroundColor: "white" }}>
        <div>
            <img alt="Logo" src={data?.url} className="h-30px logo" />
        </div>
        <div>
            <img alt="Logo" src={'/media/images/RePay.png'} className="h-30px logo" />
        </div>

    </div>

}
/**
 * UpdatePhoneHeader
 * Renders the header for phone update pages.
 */
export const UpdatePhoneHeader = () => {

    return <div className='d-flex justify-content-between  py-4 px-4 border-bottom' >
        <div>
            <img alt="Logo" src={"https://api.repayrewards.com/storage/company/22/AbC6DVUFS4jqrS7I9bo4Izz6lomUIIJIkcsdWiOc.jpg "} className="h-40px logo" />
        </div>
        <div>
            <img alt="Logo" src={'/media/images/innovative_incentive_logo1.png'} className="h-30px logo" />
        </div>

    </div>

}